import React, { useContext, useEffect, useState } from "react";
import { ethers } from "ethers";
import { ProjectContext } from "../../ProjectContext";
import { useAccount } from "wagmi";

function TeamTable() {
  const { account, esigner, settings, formatAddress, dbuser, copyaddress, Maincontract } = useContext(ProjectContext);
  const [Data, setData] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(0); // Track selected level
  const { isConnected } = useAccount();
  const [Refaddress, setRefAddress] = useState(dbuser?.ref_address || ''); // Default to dbuser?.ref_address or empty string if not set

  // Utility function to format dates
  const formatDate = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleString(); // Assuming timestamp is in seconds
  };

  const getData = async () => {
    if (!isConnected || !settings.token || esigner === null || !settings.contract) return;

    // Call contract to fetch user data
    const getUser = await Maincontract.getuserlevelteam(account, selectedLevel);
    // console.log("Tnx getUser response:", getUser);

    // Ensure getUser is not empty
    if (!getUser || getUser.length === 0) {
      console.error("No user data found for address:", account);
      setData([]);  // Set an empty array if no data
      return;
    }

    const userTeamData = await Promise.all(
      getUser.map(async (userAddress) => {
        const getUserTeam = await Maincontract.users(userAddress);
        return {
          ref_address: getUserTeam[0],  // Address 1
          address: getUserTeam[1],  // Address 2
          stake: ethers.utils.formatUnits(getUserTeam[2], 18),  // Convert BigNumber to string
          withdrawal: ethers.utils.formatUnits(getUserTeam[3], 18),  // Convert BigNumber to string
          levelreward: ethers.utils.formatUnits(getUserTeam[4], 18),  // Convert BigNumber to string
          dailyreward: ethers.utils.formatUnits(getUserTeam[5], 18),  // Convert BigNumber to string
          date: formatDate(parseInt(getUserTeam[6]._hex, 16)),  // Convert _hex to timestamp
          packageexpire: new Date(Number(ethers.utils.formatUnits(getUserTeam[7], 18)) * 1000).toLocaleString(),
          lastpackage: getUserTeam[8],  // Assuming this is already a valid date or string
          status: Number(getUserTeam[9].toString()),  // Convert BigNumber to number
          level: selectedLevel,  // Assuming level data is BigNumber
        };
      })
    );

    // console.log("Team user data:", userTeamData);
    setData(userTeamData);  // Set the state with an array of team data
  };

  // Handle level selection from the dropdown
  const handleLevelChange = (e) => {
    const level = parseInt(e.target.value); // Get the selected level value (0, 1, or 2)
    // console.log("level--------------->", level);

    setSelectedLevel(level);  // Update the state with the selected level
  };

    useEffect(() => {
        if (dbuser?.address.toLowerCase() === account.toLowerCase()) {
          getData();
        }
      }, [dbuser, account]);    
//   useEffect(() => {
//     if (dbuser?.address !== '0x0000000000000000000000000000000000000000' && dbuser !== null) {
//       getData();
//     }
//   }, [account, settings.contract, settings.token, esigner, isConnected, selectedLevel]);

  return (
    <div className="py-0" style={{ minHeight: "0px" }}>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title text-white">Team</h4>
              <button
                className="text-white btn-outline-bg-new-primary py-2 px-3"
                onClick={() => getData()}
              >
                <i className="fa fa-refresh"></i>
              </button>
            </div>
            <div className="card-body">
              <div className="mb-3 d-flex justify-content-between w-100">
                {/* Dropdown for selecting the level */}
                <label className="form-label text-white">Select Level</label>
                <select className="form-select" onChange={handleLevelChange} style={{ width: "250px" }}>
                  <option value="0">Level 1</option>
                  <option value="1">Level 2</option>
                  <option value="2">Level 3</option>
                </select>
              </div>
              <div className="table-responsive" style={{ height: "370px" }}>
                <table className="table table-responsive-md">
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }}><strong>#</strong></th>
                      <th><strong>ADDRESS</strong></th>
                      <th><strong>AMOUNT</strong></th>
                      <th><strong>LEVEL</strong></th>
                      <th><strong>DATE</strong></th>
                      <th><strong>STATUS</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    {Data.length > 0 ? (
                      Data.map((user, index) => (
                        <tr key={index}>
                          <td><strong>{index + 1}</strong></td>
                          <td>{formatAddress(user?.address)} <i className="fa fa-copy" onClick={() => copyaddress(user.address)}></i></td>
                          <td>$ {user.stake}</td>
                          <td>{selectedLevel === 0 ? 1 : "-" || selectedLevel === 1 ? 2 : "-" || selectedLevel === 2 ? 3 : "-"}</td>
                          <td>{user.date}</td>
                          <td>
                            <span className={`badge light ${user?.status === 1 ? 'badge-success' : 'badge-danger'}`}>
                              {user?.status === 1 ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">No data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeamTable;